import stepStyles from "../../SelectProperty/SelectPropertyTypePage.module.css";

export const ResidentialNeighborhoodWearStepPage = () => {
  return (
    <>
      <div className={stepStyles.wearDescription}>
        Upload photos or documents that show the condition of your neighborhood. This helps
        demonstrate a decrease in taxable value. This is an optional step and can be skipped if you
        do not have any neighborhood wear to upload.
      </div>

      <div className={stepStyles.wearExamplesCard}>
        <div className={stepStyles.wearExamplesTitle}>Examples of what to upload:</div>
        <ul className={stepStyles.wearExamplesList}>
          <li>Photos of damaged areas</li>
          <li>Repair estimates</li>
          <li>Inspection reports</li>
          <li>Maintenance issues documentation</li>
        </ul>
      </div>
    </>
  );
};
